module.exports = __webpack_public_path__ + "img/minjiang3.b7663ffc.png";